/* template */
<template minapp="mpx" xlang="wxml"><div class="es-refund-card" v-if="(content!=null && content.length > 0)"><div class="es-refund-card__header"><div class="es-refund-card__title">{{title}}</div><div class="es-refund-card__title-tips">{{titleTips}}</div></div><div class="es-refund-card__divider"></div><es-radio-group :value="selected" mpxModelEvent="input" @mpxModel='__model("selected", $event, ["value"], undefined)' direction="column" @input="onClick"><div v-for="(item, index) in (content)" :key="item.index"><es-radio label-position="left" label-class="label-class" :name="(item)" useIconSlot :icon-style="({borderRadius: '6px'})" :iconSize="(18)"><es-icon slot="icon" size="10" name="check-filled" :style="[(checkboxIconStyle)] | transRpxStyle"/><div class="es-refund-card__content in"><div class="es-refund-card__item">{{item}}</div><div class="es-refund-card__title-tips" v-if="(item == '其他')">{{reasonTips}}</div></div></es-radio></div></es-radio-group><mpx-textarea :maxlength="(100)" placeholder="可填写原因说明，最多填写100字，超出不可继续填写" @input="onClick($event)" :value="inputdata" mpxModelEvent="input" @mpxModel='__model("inputdata", $event, ["value"], undefined)' class="es-refund-card__input" v-if="(selected=='其他')"/></div></template>

/* styles */
<style lang="stylus" src="./style.styl" scoped mpxStyleOptions='{"mid":"m8bde42f6"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m8bde42f6"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex8bde42f6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex8bde42f6%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m8bde42f6"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index8bde42f6/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-checkbox':getComponent(require("../../es-mpx-ui/lib/checkbox/index.mpx?isComponent&outputPath=components%2Findex8e1a7e44%2Findex")),'es-radio':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/radio/index.mpx?isComponent&outputPath=components%2Findex1da48bb6%2Findex")),'es-radio-group':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/radio-group/index.mpx?isComponent&outputPath=components%2Findex10772dd7%2Findex")),'mpx-textarea':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-textarea.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
